import { render, staticRenderFns } from "./FilterItemInactive.vue?vue&type=template&id=38c77c7b&scoped=true&"
import script from "./FilterItemInactive.vue?vue&type=script&lang=js&"
export * from "./FilterItemInactive.vue?vue&type=script&lang=js&"
import style0 from "./FilterItemInactive.vue?vue&type=style&index=0&id=38c77c7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c77c7b",
  null
  
)

export default component.exports